/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { logger as log } from '@common/logger';

import { Sttp } from '@common/sttp';
import { apiConfig } from '@/config/apiConfig';
import { AppNavigatorService } from '@/AppNavigator/services';
import { vappContainer } from '@/application';

export interface IGetAccessTokenProps {
  jwtToken?: string;
  role?: string;
}

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export interface IGetAccessTokenMethods extends IPluginMethodMap {
  getAccessTokenProps(args: IGetAccessTokenProps): Promise<any>;
}

export interface IGetAccessTokenMethods extends IPluginMethodMap {
  getAccessTokenProps(args: IGetAccessTokenProps): Promise<any>;
}

export class GetAccessTokenPlugin implements IAgentPlugin {
  readonly methods: IGetAccessTokenMethods;

  constructor() {
    this.methods = {
      getAccessTokenProps: this.getProps.bind(this),
    };
  }

  async getProps(args: IGetAccessTokenProps) {
    console.log(`args send otp`, args);
    return await this.GetAccessToken(args);
  }

  private async GetAccessToken(args: IGetAccessTokenProps) {
    try {
      let sttp = Sttp.withBaseUrl(apiConfig.rest.url);
      //  sttp =  sttp
      //     .withQueryParams({ page: 3 })
      //     .withHeaders({ 'X-API-Token': 123 })
      //     .withPayload({ name: 'Supercharge' })
      // const res = await sttp.post(`/your_url`);

      const res = await sttp.post(apiConfig?.accessTokenEP, {
        jwtToken: args?.jwtToken,
        role: args?.role,
      });
      if (res?.isError()) {
        log.error(
          `error in post status=${res.status()} statusText=${res.statusText()}`
        );
      }
      log.log('result of post=', res.data());
      return res.data();
    } catch (err: any) {
      log.error('error in post=', err?.message);
      throw err;
    }
  }
}
